__webpack_require__.p = "/video_upload_react/";